import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "حاسبة الإقلاع عن التدخين";
const DESCRIPTION = "اكتشف فوائد الإقلاع عن التدخين ومدى التحسن في صحتك";
const KEYWORDS = "التدخين, الإقلاع عن التدخين, الصحة";
const OG_URL =
  "https://do-calculate.com/calculator/ar/smoking-recovery-calculator/";
function SmokingRecoveryCalculator() {
  const [smokePerDay, setSmokePerDay] = useState(0);
  const [smokingDuration, setSmokingDuration] = useState(0);
  const [quitDate, setQuitDate] = useState(new Date());
  const [result, setResult] = useState();
  const [error, setError] = useState("");
  const arabicWeekdays = [
    "الأحد",
    "الاثنين",
    "الثلاثاء",
    "الأربعاء",
    "الخميس",
    "الجمعة",
    "السبت",
  ];
  const formatDate = (date) => {
    const day = arabicWeekdays[date.getDay()];
    const month = date.getMonth() + 1;
    const dayOfMonth = date.getDate();
    const year = date.getFullYear();
    return `${day}, ${dayOfMonth}-${month}-${year}`;
  };
  const handleCalculate = () => {
    try {
      const cigarettesPerDay = parseInt(smokePerDay);
      const lifeGain = Math.floor((cigarettesPerDay / 10) * 5);
      const heartRateDropDate = new Date(quitDate);
      heartRateDropDate.setDate(quitDate.getDate() + 1);
      const anxietyDate = new Date(heartRateDropDate);
      anxietyDate.setDate(heartRateDropDate.getDate() + 2);
      const symptomsDiminishDate = new Date(anxietyDate);
      symptomsDiminishDate.setDate(anxietyDate.getDate() + 14);
      const symptomsDisappearDate = new Date(symptomsDiminishDate);
      symptomsDisappearDate.setDate(symptomsDiminishDate.getDate() + 14);
      setResult({
        lifeGain,
        heartRateDropDate: formatDate(heartRateDropDate),
        anxietyDate: formatDate(anxietyDate),
        symptomsDiminishDate: formatDate(symptomsDiminishDate),
        symptomsDisappearDate: formatDate(symptomsDisappearDate),
      });
    } catch (error) {
      setError(error.message);
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  هذه الحاسبة تساعدك في معرفة الفوائد الصحية للإقلاع عن التدخين
                </p>
                <p>
                  اكتشف كنوز صحتك المخبأة! هل تتساءل عن الفوائد الحقيقية للإقلاع
                  عن التدخين؟ هذه الحاسبة تساعدك على استكشاف التحسينات المذهلة
                  التي ستحدث لجسمك وعقلك. بمجرد الإقلاع عن التدخين، ستلاحظ
                  انخفاضًا ملحوظًا في معدل ضربات قلبك وتحسنًا في مستويات القلق،
                  بالإضافة إلى فوائد صحية عامة أخرى. ابدأ رحلة استعادة صحتك
                  اليوم!
                </p>
                <p>
                  هل أنت مستعد للاستمتاع بحياة أكثر صحة وسعادة؟ الإقلاع عن
                  التدخين هو الخطوة الأولى نحو ذلك. ستلاحظ تحسنًا ملحوظًا في
                  صحتك العامة، بما في ذلك زيادة الطاقة وتحسن في التنفس. استخدم
                  هذه الحاسبة لتقدير الفوائد الصحية التي ستحصل عليها. تذكر أنك
                  لست وحدك، وهناك العديد من الأشخاص الذين يرغبون في مساعدتك.
                </p>
                <p>
                  <b>
                    هام: يجب التأكيد على أن هذه الحاسبة هي أداة مساعدة فقط، وأن
                    النتائج قد تختلف من شخص لآخر. في حال كنت ترغب في الحصول على
                    معلومات أكثر تفصيلاً، يجب عليك استشارة طبيب أو متخصص في
                    الصحة.
                  </b>
                </p>
                <p>
                  {" "}
                  تم تطوير الحاسبة بالاعتماد على{" "}
                  <a
                    href="https://academic.oup.com/ntr/article/9/3/315/1100099"
                    rel="nofollow"
                  >
                    موقع أوكسفورد الأكاديمي
                  </a>
                </p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div dir="rtl">
                  <div>
                    <hr />
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="dose">
                        عدد السجائر يومياً
                      </label>
                      <input
                        id="dose"
                        type="number"
                        value={smokePerDay}
                        onChange={(e) => setSmokePerDay(e.target.value)}
                        placeholder="أدخل عدد السجائر"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group">
                      <label
                        className="form-label ms-2"
                        htmlFor="numberOfTimes"
                      >
                        مدة التدخين (بالسنوات)
                      </label>
                      <input
                        id="numberOfTimes"
                        type="number"
                        value={smokingDuration}
                        onChange={(e) => setSmokingDuration(e.target.value)}
                        placeholder="أدخل مدة التدخين"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="date">
                        تاريخ الإقلاع
                      </label>
                      <input
                        id="date"
                        type="date"
                        value={quitDate.toISOString().substring(0, 10)}
                        onChange={(e) => setQuitDate(new Date(e.target.value))}
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={handleCalculate}
                    >
                      احسب                    </button>
                  </div>
                  <br />
                  { error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      خطأ: {error}
                    </p>
                  )}
                  {result &&  (
                    <div className="p-3 mb-2 bg-success text-white">
                      <h4>النتيجة:</h4>
                      <p className="text-white">
                        السنوات المكتسبة: {result.lifeGain} سنوات
                      </p>
                      <p className="text-white">
                        معدل ضربات القلب ينخفض في: {result.heartRateDropDate}
                      </p>
                      <p className="text-white">
                        القلق يظهر في: {result.anxietyDate}
                      </p>
                      <p className="text-white">
                        الأعراض تتضاءل في: {result.symptomsDiminishDate}
                      </p>
                      <p className="text-white">
                        الأعراض تختفي بالكامل في: {result.symptomsDisappearDate}
                      </p>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">مزيد من التفاصيل</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>التعافي من التدخين</h2>{" "}
                  </u>
                  <p>
                    الإقلاع عن التدخين يمكن أن يضيف سنوات إلى حياتك ويحسن صحتك
                    بشكل كبير.
                  </p>
                  <div className="p-3 mb-2 bg-info ">
                    يمكن أن يحسن صحة القلب والرئتين
                  </div>
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      الفوائد المبكرة للإقلاع
                    </h2>{" "}
                  </u>
                  <p>
                    خلال 24 ساعة من التوقف عن التدخين، يبدأ الجسم في التعافي.
                    معدل ضربات القلب ينخفض، ومستويات الأكسجين في الدم تتحسن.
                    تبدأ حاسة الشم والتذوق في التحسن خلال أيام.
                  </p>
                </div>
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>سنة بعد الإقلاع </h2>{" "}
                  </u>
                  <p>
                    بعد سنة من التوقف عن التدخين، يتحسن أداء الرئة، وتقل معدلات
                    الإصابة بأمراض القلب. يتم تحسين القدرة البدنية، وتشعر بأن
                    التنفس أصبح أسهل.
                  </p>
                </div>
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>الفوائد طويلة الأمد </h2>{" "}
                  </u>
                  <p>
                    بعد مرور 10 سنوات على التوقف، ينخفض خطر الإصابة بسرطان الرئة
                    بنسبة 50٪. وبعد 15 عامًا، يكون خطر الإصابة بأمراض القلب
                    مشابهًا لغير المدخنين.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default SmokingRecoveryCalculator;
